var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { px2rem } from 'smartpi-core';
import styled from 'styled-components';
// import { withStyleProps } from './base';
// interface BoxProps {
//   test: string;
// }
// const BaseBox = styled<BoxProps, 'div'>('div')`
//   content: ${props => props.test};
// `;
// const Box = withStyleProps<BoxProps>(BaseBox);
// //  as Component<BoxProps & { width?: number; height?: number }>;
// export { Box };
var Box = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ",
    ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ",
    ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) {
    if (props.w) {
        if (props.w < 1) {
            return "width:" + props.w * 100 + "%;";
        }
        return "width:" + px2rem(props.w) + ";";
    }
    return "";
}, function (props) {
    if (typeof props.h === 'number') {
        return "height:" + px2rem(props.h) + ";";
    }
    if (typeof props.h === 'string') {
        return "height:" + props.h + ";";
    }
    return '';
}, function (props) {
    if (props.m && props.m.length && typeof props.m !== 'string') {
        return "margin:" + px2rem(props.m[0]) + " " + px2rem(props.m[1]) + " " + px2rem(props.m[2]) + " " + px2rem(props.m[3]);
    }
    if (typeof props.m === 'string') {
        return "margin:" + props.m;
    }
    return "";
}, function (props) {
    if (typeof props.l === 'number') {
        return "left: " + px2rem(props.l);
    }
    return "";
}, function (props) {
    if (typeof props.t === 'number') {
        return "top: " + px2rem(props.t);
    }
    return "";
}, function (props) {
    if (typeof props.r === 'number') {
        return "right: " + px2rem(props.r);
    }
    return "";
}, function (props) {
    if (typeof props.b === 'number') {
        return "bottom: " + px2rem(props.b);
    }
    return "";
}, function (props) { return (props.mt ? "margin-top:" + px2rem(props.mt) + ";" : ""); }, function (props) { return (props.mr ? "margin-right:" + px2rem(props.mr) + ";" : ""); }, function (props) { return (props.mb ? "margin-bottom:" + px2rem(props.mb) + ";" : ""); }, function (props) { return (props.ml ? "margin-left:" + px2rem(props.ml) + ";" : ""); }, function (props) {
    if (props.p) {
        if (props.p.length === 1) {
            return "padding: " + px2rem(props.p[0]);
        }
        if (props.p.length === 2) {
            return "padding: " + px2rem(props.p[0]) + " " + px2rem(props.p[1]);
        }
        if (props.p.length === 4) {
            return "padding: " + px2rem(props.p[0]) + " " + px2rem(props.p[1]) + " " + px2rem(props.p[2]) + " " + px2rem(props.p[3]);
        }
    }
    return "";
}, function (props) { return (props.pt ? "padding-top:" + px2rem(props.pt) + ";" : ""); }, function (props) { return (props.pr ? "padding-right:" + px2rem(props.pr) + ";" : ""); }, function (props) { return (props.pb ? "padding-bottom:" + px2rem(props.pb) + ";" : ""); }, function (props) { return (props.pl ? "padding-left:" + px2rem(props.pl) + ";" : ""); }, function (props) {
    if (props.br) {
        if (props.br.length === 1) {
            return "border-radius: " + px2rem(props.br[0]);
        }
        if (props.br.length === 4) {
            return "border-radius: " + px2rem(props.br[0]) + " " + px2rem(props.br[1]) + " " + px2rem(props.br[2]) + " " + px2rem(props.br[3]);
        }
    }
    return "";
}, function (props) { return (props.lh ? "line-height:" + px2rem(props.lh) + ";" : ""); }, function (props) { return (props.ta ? "text-align: " + props.ta + ";" : ""); }, function (props) { return (props.bg ? "background: " + props.bg + ";" : ""); }, function (props) { return (props.bgC ? "background-color: " + props.bgC + ";" : ""); }, function (props) { return (props.bgSize ? "background-size: " + props.bgSize + ";" : ""); }, function (props) { return (props.c ? "color: " + props.c + ";" : ""); }, function (props) { return (props.fs ? "font-size: " + props.fs + ";" : ""); }, function (props) { return (props.fw ? "font-weight: " + props.fw + ";" : ""); }, function (props) { return (props.flex ? "flex: " + props.flex + ";" : ""); }, function (props) { return (props.position ? "position: " + props.position + ";" : ""); }, function (props) { return (props.border ? "border: " + props.border + ";" : ""); }, function (props) { return (props.borderL ? "border-left: " + props.borderL + ";" : ""); }, function (props) { return (props.shadow ? "box-shadow: " + props.shadow + ";" : ""); }, function (props) { return (props.zIndex ? "z-index: " + props.zIndex + ";" : ""); }, function (props) { return (props.verAli ? "vertical-align: " + props.verAli + ";" : ""); }, function (props) { return (props.letterSpacing ? "letter-spacing: " + px2rem(props.letterSpacing) : ""); }, function (props) { return (props.textDecoration ? "text-decoration:" + props.textDecoration + ";" : ""); }, function (props) { return (props.float ? "float: " + props.float + ";" : ""); });
var CardTitle = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  text-align: center;\n"], ["\n  margin-bottom: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  text-align: center;\n"])), px2rem(50), function (props) { return props.theme.color.black[2]; }, function (props) { return props.theme.fontSize[1]; }, function (props) { return props.theme.fontSize[1]; });
var Flex = styled('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n"])), function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? 'row' : _b;
    return direction;
}, function (_a) {
    var _b = _a.alignItem, alignItem = _b === void 0 ? 'flex-start' : _b;
    return alignItem;
}, function (_a) {
    var _b = _a.justifyContent, justifyContent = _b === void 0 ? 'flex-start' : _b;
    return justifyContent;
});
export { Box, CardTitle, Flex };
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Base.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/styled-system/Base.js
// module id = 1219
// module chunks = 0